// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   HiOutlineUser,
//   HiOutlineMail,
//   HiOutlinePhone,
//   HiOutlineLocationMarker,
//   HiOutlineAcademicCap,
//   HiOutlineBriefcase,
//   HiOutlineIdentification,
//   HiOutlineCalendar,
//   HiOutlinePencil,
//   HiOutlineCheck,
//   HiOutlineX,
//   HiOutlinePlusCircle,
//   HiOutlineBookOpen,
//   HiOutlineOfficeBuilding
// } from "react-icons/hi";
// import axios from "axios";
// import Cookies from "js-cookie";
// import { toast } from "react-toastify";

// const UserProfile = () => {
//   const [profile, setProfile] = useState(null);
//   const [educationalData, setEducationalData] = useState(null);
//   const [editModalOpen, setEditModalOpen] = useState(false);
//   const [educationModalOpen, setEducationModalOpen] = useState(false);
//   const [editData, setEditData] = useState({ email: "", phone: "", address: "" });
//   const [educationData, setEducationData] = useState({
//     collegeName: "",
//     graduationYear: "",
//     degree: "",
//     department: "",
//     studentId: ""
//   });
//   const [errors, setErrors] = useState({});
//   const [educationErrors, setEducationErrors] = useState({});
//   const token = Cookies.get("userToken");

//   useEffect(() => {
//     const getProfileData = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_BACKEND_URL}/apis/user/getSingleUserProfile`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );


//         const data = res.data.data;
//         setProfile({
//           fullName: data.user?.fullName || "",
//           email: data.user?.email || "",
//           phoneNumber: data.user?.phoneNumber || "",
//           address: data.user?.address || "",
//           image: data.user?.image || ""
//         });

//         setEducationalData(data.academicInformation || null);

//         // If educational data exists, populate the education form
//         if (data.academicInformation) {
//           setEducationData({
//             collegeName: data.academicInformation.collegeName || "",
//             graduationYear: data.academicInformation.graduationYear || "",
//             degree: data.academicInformation.degree || "",
//             department: data.academicInformation.department || ""
//           });
//         }
//       } catch (error) {
//         console.log("Error fetching profile", error);
//       }
//     };

//     if (token) {
//       getProfileData();
//     }
//   }, [token]);

//   const validateForm = () => {
//     const newErrors = {};
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^[0-9]{10}$/;

//     if (!emailRegex.test(editData.email)) {
//       newErrors.email = "Invalid email format";
//     }

//     if (!phoneRegex.test(editData.phone)) {
//       newErrors.phone = "Phone must be 10 digits";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const validateEducationForm = () => {
//     const newErrors = {};

//     if (!educationData.collegeName.trim()) {
//       newErrors.collegeName = "College name is required";
//     }
//     if (!educationData.graduationYear) {
//       newErrors.graduationYear = "Graduation year is required";
//     } else if (educationData.graduationYear < 1950 || educationData.graduationYear > 2030) {
//       newErrors.graduationYear = "Please enter a valid year";
//     }
//     if (!educationData.degree.trim()) {
//       newErrors.degree = "Degree is required";
//     }
//     if (!educationData.department.trim()) {
//       newErrors.department = "Department is required";
//     }
    

//     setEducationErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleEditClick = () => {
//     setEditData({
//       email: profile?.email || "",
//       phone: profile?.phoneNumber || "",
//       address: profile?.address || "",
//     });
//     setEditModalOpen(true);
//   };

//   const handleEducationEditClick = () => {
//     setEducationData({
//       collegeName: educationalData?.collegeName || "",
//       graduationYear: educationalData?.graduationYear || "",
//       degree: educationalData?.degree || "",
//       department: educationalData?.department || ""
//     });
//     setEducationErrors({});
//     setEducationModalOpen(true);
//   };

//   const handleUpdate = async () => {
//     if (!validateForm()) return;

//     try {
//       const response = await axios.put(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/updateUserProfile`,
//         {
//           email: editData.email,
//           phoneNumber: editData.phone,
//           address: editData.address,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setProfile(prev => ({
//         ...prev,
//         email: editData.email,
//         phoneNumber: editData.phone,
//         address: editData.address
//       }));

//       toast.success("Profile updated successfully");
//       setEditModalOpen(false);
//     } catch (error) {
//       console.error("Error updating profile", error);
//       toast.error("Failed to update profile");
//     }
//   };

//   const handleEducationUpdate = async () => {
//     if (!validateEducationForm()) return;

//     try {
//       console.log("Current educationalData before update:", educationalData);
//       console.log("Sending update with data:", {
//         collegeName: educationData.collegeName,
//         graduationYear: parseInt(educationData.graduationYear),
//         degree: educationData.degree,
//         department: educationData.department
//       });

//       const response = await axios.put(
//         `${process.env.REACT_APP_BACKEND_URL}/apis/user/updateAcademicInformation`,
//         {
//           collegeName: educationData.collegeName,
//           graduationYear: parseInt(educationData.graduationYear),
//           degree: educationData.degree,
//           department: educationData.department
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       console.log("Response from server:", response.data);

//       if (response.data && response.data.data) {
//         // Update the state with the response data
//         setEducationalData(response.data.data);
//         toast.success(response.data.message || "Academic information saved successfully");
//         setEducationModalOpen(false);
//       } else {
//         // If response doesn't have the expected structure, still close modal
//         toast.success("Academic information saved successfully");
//         setEducationModalOpen(false);
//       }
//     } catch (error) {
//       console.error("Error updating academic information:", error);
//       console.log("Error response:", error.response?.data);

//       // Show specific error message if available
//       if (error.response?.data?.message) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error("Failed to save academic information");
//       }
//     }
//   };

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2
//       }
//     }
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.5 }
//     }
//   };

//   const modalVariants = {
//     hidden: { opacity: 0, scale: 0.8 },
//     visible: {
//       opacity: 1,
//       scale: 1,
//       transition: { duration: 0.3 }
//     },
//     exit: {
//       opacity: 0,
//       scale: 0.8,
//       transition: { duration: 0.2 }
//     }
//   };

//   if (!profile) {
//     return (
//       <div className="w-full bg-gradient-to-br from-gray-50 via-white to-gray-50 rounded-2xl shadow-xl p-8 border border-gray-200">
//         <div className="flex items-center justify-center h-64">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <motion.div
//       variants={containerVariants}
//       initial="hidden"
//       animate="visible"
//       className="w-full bg-gradient-to-br from-gray-50 via-white to-gray-50 rounded-3xl shadow-xl p-6 md:p-8 border border-gray-200"
//     >
//       {/* Profile Header */}
//       <motion.div variants={itemVariants} className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-gray-200">
//         <button
//           onClick={handleEditClick}
//           className="absolute top-4 right-4 p-3 bg-gray-100 hover:bg-gray-200 rounded-full transition shadow-md group"
//           title="Edit Personal Information"
//         >
//           <HiOutlinePencil className="w-5 h-5 text-gray-600 group-hover:scale-110 transition" />
//         </button>

//         <div className="flex flex-col items-center">
//           <div className="relative group mb-4">
//             <img
//               src={profile?.image || "/assets/DefaultImage.jpg"}
//               alt="Profile"
//               className="w-28 h-28 rounded-full object-cover ring-4 ring-gray-200 shadow-xl group-hover:ring-gray-300 transition"
//             />
//             <div className="absolute bottom-0 right-0 bg-gradient-to-r from-gray-100 to-gray-200 text-gray-600 rounded-full p-2 shadow-lg border border-gray-200">
//               <HiOutlineCheck className="w-4 h-4" />
//             </div>
//           </div>
//           <h2 className="text-2xl md:text-3xl font-bold text-gray-700">
//             {profile?.fullName || "Not Available"}
//           </h2>
//           <p className="text-gray-500 text-sm mt-2 flex items-center">
//             <HiOutlineLocationMarker className="w-4 h-4 mr-1 text-gray-400" />
//             {profile?.address || "Location not set"}
//           </p>
//         </div>
//       </motion.div>

//       {/* Personal Info */}
//       <motion.div variants={itemVariants} className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-gray-200">
//         <h3 className="text-xl font-bold text-gray-700 mb-6 flex items-center">
//           <HiOutlineUser className="w-5 h-5 mr-2 text-gray-500" />
//           Personal Information
//         </h3>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           <div className="space-y-2">
//             <label className="text-sm font-semibold text-gray-600 flex items-center">
//               <HiOutlineMail className="w-4 h-4 mr-2 text-gray-500" />
//               Email Address
//             </label>
//             <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
//               {profile?.email || "Not Available"}
//             </p>
//           </div>

//           <div className="space-y-2">
//             <label className="text-sm font-semibold text-gray-600 flex items-center">
//               <HiOutlinePhone className="w-4 h-4 mr-2 text-gray-500" />
//               Phone Number
//             </label>
//             <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
//               {profile?.phoneNumber || "Not Available"}
//             </p>
//           </div>

//           <div className="space-y-2 md:col-span-2">
//             <label className="text-sm font-semibold text-gray-600 flex items-center">
//               <HiOutlineLocationMarker className="w-4 h-4 mr-2 text-gray-500" />
//               Address
//             </label>
//             <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
//               {profile?.address || "Not Available"}
//             </p>
//           </div>
//         </div>
//       </motion.div>

//       {/* Education */}
//       <motion.div variants={itemVariants} className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-200">
//         <div className="flex items-center justify-between mb-6">
//           <h3 className="text-xl font-bold text-gray-700 flex items-center">
//             <HiOutlineAcademicCap className="w-5 h-5 mr-2 text-gray-500" />
//             Education
//           </h3>
//           <button
//             onClick={handleEducationEditClick}
//             className="flex items-center space-x-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition group"
//             title={educationalData ? "Edit Education" : "Add Education"}
//           >
//             {educationalData ? (
//               <>
//                 <HiOutlinePencil className="w-4 h-4 text-gray-600 group-hover:scale-110 transition" />
//                 <span className="text-sm text-gray-700">Edit</span>
//               </>
//             ) : (
//               <>
//                 <HiOutlinePlusCircle className="w-4 h-4 text-gray-600 group-hover:scale-110 transition" />
//                 <span className="text-sm text-gray-700">Add Education</span>
//               </>
//             )}
//           </button>
//         </div>

//         {educationalData ? (
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div className="space-y-2">
//               <label className="text-sm font-semibold text-gray-600">College Name</label>
//               <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
//                 {educationalData?.collegeName || "Not Available"}
//               </p>
//             </div>

//             <div className="space-y-2">
//               <label className="text-sm font-semibold text-gray-600">Graduation Year</label>
//               <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
//                 {educationalData?.graduationYear || "Not Available"}
//               </p>
//             </div>

//             <div className="space-y-2">
//               <label className="text-sm font-semibold text-gray-600">Degree</label>
//               <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
//                 {educationalData?.degree || "Not Available"}
//               </p>
//             </div>

//             <div className="space-y-2">
//               <label className="text-sm font-semibold text-gray-600">Department</label>
//               <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
//                 {educationalData?.department || "Not Available"}
//               </p>
//             </div>


//           </div>
//         ) : (
//           <div className="text-center py-8 bg-gray-50 rounded-xl border border-gray-200">
//             <HiOutlineAcademicCap className="w-12 h-12 text-gray-400 mx-auto mb-3" />
//             <p className="text-gray-500">No education information added yet</p>
//             <p className="text-sm text-gray-400 mt-1">Click the "Add Education" button to add your academic details</p>
//           </div>
//         )}
//       </motion.div>

//       {/* Edit Personal Info Modal */}
//       <AnimatePresence>
//         {editModalOpen && (
//           <motion.div
//             variants={modalVariants}
//             initial="hidden"
//             animate="visible"
//             exit="exit"
//             className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
//             onClick={() => setEditModalOpen(false)}
//           >
//             <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 w-full max-w-md border border-gray-200" onClick={(e) => e.stopPropagation()}>
//               <h2 className="text-2xl font-bold text-gray-700 mb-6">
//                 Edit Contact Info
//               </h2>

//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
//                   <input
//                     type="email"
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
//                     value={editData.email}
//                     onChange={(e) => setEditData({ ...editData, email: e.target.value })}
//                   />
//                   {errors.email && (
//                     <p className="text-red-500 text-sm mt-1 flex items-center">
//                       <HiOutlineX className="w-4 h-4 mr-1" />
//                       {errors.email}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="text"
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
//                     value={editData.phone}
//                     onChange={(e) => setEditData({ ...editData, phone: e.target.value })}
//                   />
//                   {errors.phone && (
//                     <p className="text-red-500 text-sm mt-1 flex items-center">
//                       <HiOutlineX className="w-4 h-4 mr-1" />
//                       {errors.phone}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Address</label>
//                   <input
//                     type="text"
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
//                     value={editData.address}
//                     onChange={(e) => setEditData({ ...editData, address: e.target.value })}
//                   />
//                 </div>
//               </div>

//               <div className="flex justify-end space-x-3 mt-8">
//                 <button
//                   className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
//                   onClick={() => setEditModalOpen(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="px-6 py-2.5 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition font-medium shadow-sm"
//                   onClick={handleUpdate}
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Edit Education Modal */}
//       <AnimatePresence>
//         {educationModalOpen && (
//           <motion.div
//             variants={modalVariants}
//             initial="hidden"
//             animate="visible"
//             exit="exit"
//             className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
//             onClick={() => setEducationModalOpen(false)}
//           >
//             <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 w-full max-w-md border border-gray-200 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
//               <h2 className="text-2xl font-bold text-gray-700 mb-6 flex items-center">
//                 <HiOutlineAcademicCap className="w-6 h-6 mr-2 text-gray-500" />
//                 {educationalData ? "Edit Education" : "Add Education"}
//               </h2>

//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">College Name</label>
//                   <input
//                     type="text"
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
//                     placeholder="e.g., Stanford University"
//                     value={educationData.collegeName}
//                     onChange={(e) => setEducationData({ ...educationData, collegeName: e.target.value })}
//                   />
//                   {educationErrors.collegeName && (
//                     <p className="text-red-500 text-sm mt-1 flex items-center">
//                       <HiOutlineX className="w-4 h-4 mr-1" />
//                       {educationErrors.collegeName}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Graduation Year</label>
//                   <input
//                     type="number"
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
//                     placeholder="e.g., 2024"
//                     value={educationData.graduationYear}
//                     onChange={(e) => setEducationData({ ...educationData, graduationYear: e.target.value })}
//                   />
//                   {educationErrors.graduationYear && (
//                     <p className="text-red-500 text-sm mt-1 flex items-center">
//                       <HiOutlineX className="w-4 h-4 mr-1" />
//                       {educationErrors.graduationYear}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Degree</label>
//                   <input
//                     type="text"
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
//                     placeholder="e.g., Bachelor of Science"
//                     value={educationData.degree}
//                     onChange={(e) => setEducationData({ ...educationData, degree: e.target.value })}
//                   />
//                   {educationErrors.degree && (
//                     <p className="text-red-500 text-sm mt-1 flex items-center">
//                       <HiOutlineX className="w-4 h-4 mr-1" />
//                       {educationErrors.degree}
//                     </p>
//                   )}
//                 </div>

//                 <div>
//                   <label className="block text-sm font-semibold text-gray-700 mb-2">Department</label>
//                   <input
//                     type="text"
//                     className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
//                     placeholder="e.g., Computer Science"
//                     value={educationData.department}
//                     onChange={(e) => setEducationData({ ...educationData, department: e.target.value })}
//                   />
//                   {educationErrors.department && (
//                     <p className="text-red-500 text-sm mt-1 flex items-center">
//                       <HiOutlineX className="w-4 h-4 mr-1" />
//                       {educationErrors.department}
//                     </p>
//                   )}
//                 </div>


//               </div>

//               <div className="flex justify-end space-x-3 mt-8">
//                 <button
//                   className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
//                   onClick={() => setEducationModalOpen(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="px-6 py-2.5 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition font-medium shadow-sm"
//                   onClick={handleEducationUpdate}
//                 >
//                   {educationalData ? "Update" : "Save"} Education
//                 </button>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.div>
//   );
// };

// export default UserProfile;



import React, { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  HiOutlineUser,
  HiOutlineMail,
  HiOutlinePhone,
  HiOutlineLocationMarker,
  HiOutlineAcademicCap,
  HiOutlineBriefcase,
  HiOutlineIdentification,
  HiOutlineCalendar,
  HiOutlinePencil,
  HiOutlineCheck,
  HiOutlineX,
  HiOutlinePlusCircle,
  HiOutlineBookOpen,
  HiOutlineOfficeBuilding,
  HiOutlineCamera,
  HiOutlinePhotograph,
  HiOutlineUpload,
  HiOutlineRefresh
} from "react-icons/hi";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const UserProfile = () => {
  const [profile, setProfile] = useState(null);
  const [educationalData, setEducationalData] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [educationModalOpen, setEducationModalOpen] = useState(false);
  const [editData, setEditData] = useState({ email: "", phone: "", address: "" });
  const [educationData, setEducationData] = useState({
    collegeName: "",
    graduationYear: "",
    degree: "",
    department: "",
    studentId: ""
  });
  const [errors, setErrors] = useState({});
  const [educationErrors, setEducationErrors] = useState({});
  
  // New state for image upload
  const [uploadingImage, setUploadingImage] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);
  
  const token = Cookies.get("userToken");

  useEffect(() => {
    const getProfileData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/apis/user/getSingleUserProfile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = res.data.data;
        setProfile({
          fullName: data.user?.fullName || "",
          email: data.user?.email || "",
          phoneNumber: data.user?.phoneNumber || "",
          address: data.user?.address || "",
          image: data.user?.image || ""
        });

        console.log("data: ", data);

        setEducationalData(data.academicInformation || null);

        // If educational data exists, populate the education form
        if (data.academicInformation) {
          setEducationData({
            collegeName: data.academicInformation.collegeName || "",
            graduationYear: data.academicInformation.graduationYear || "",
            degree: data.academicInformation.degree || "",
            department: data.academicInformation.department || ""
          });
        }
      } catch (error) {
        console.log("Error fetching profile", error);
      }
    };

    if (token) {
      getProfileData();
    }
  }, [token]);

  // Handle image selection
  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      toast.error("Please select a valid image file (JPEG, PNG, GIF, WEBP)");
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image size should be less than 5MB");
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setImagePreview(reader.result);
    };
    reader.readAsDataURL(file);

    // Upload the image
    uploadProfileImage(file);
  };

  // Upload profile image
  const uploadProfileImage = async (file) => {
    const formData = new FormData();
    formData.append('profileImage', file); // Field name must match backend

    setUploadingImage(true);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/apis/user/updateProfileImage`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.data.success) {
        // Update profile with new image URL
        setProfile(prev => ({
          ...prev,
          image: response.data.data.imageUrl
        }));
        
        // Clear preview
        setImagePreview(null);
        
        toast.success("Profile image updated successfully!");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      toast.error(error.response?.data?.message || "Failed to upload image");
      setImagePreview(null);
    } finally {
      setUploadingImage(false);
    }
  };

  // Trigger file input click
  const handleCameraClick = () => {
    fileInputRef.current.click();
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;

    if (!emailRegex.test(editData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!phoneRegex.test(editData.phone)) {
      newErrors.phone = "Phone must be 10 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateEducationForm = () => {
    const newErrors = {};

    if (!educationData.collegeName.trim()) {
      newErrors.collegeName = "College name is required";
    }
    if (!educationData.graduationYear) {
      newErrors.graduationYear = "Graduation year is required";
    } else if (educationData.graduationYear < 1950 || educationData.graduationYear > 2030) {
      newErrors.graduationYear = "Please enter a valid year";
    }
    if (!educationData.degree.trim()) {
      newErrors.degree = "Degree is required";
    }
    if (!educationData.department.trim()) {
      newErrors.department = "Department is required";
    }
    

    setEducationErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditClick = () => {
    setEditData({
      email: profile?.email || "",
      phone: profile?.phoneNumber || "",
      address: profile?.address || "",
    });
    setEditModalOpen(true);
  };

  const handleEducationEditClick = () => {
    setEducationData({
      collegeName: educationalData?.collegeName || "",
      graduationYear: educationalData?.graduationYear || "",
      degree: educationalData?.degree || "",
      department: educationalData?.department || ""
    });
    setEducationErrors({});
    setEducationModalOpen(true);
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/apis/user/updateUserProfile`,
        {
          email: editData.email,
          phoneNumber: editData.phone,
          address: editData.address,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setProfile(prev => ({
        ...prev,
        email: editData.email,
        phoneNumber: editData.phone,
        address: editData.address
      }));

      toast.success("Profile updated successfully");
      setEditModalOpen(false);
    } catch (error) {
      console.error("Error updating profile", error);
      toast.error("Failed to update profile");
    }
  };

  const handleEducationUpdate = async () => {
    if (!validateEducationForm()) return;

    try {
      console.log("Current educationalData before update:", educationalData);
      console.log("Sending update with data:", {
        collegeName: educationData.collegeName,
        graduationYear: parseInt(educationData.graduationYear),
        degree: educationData.degree,
        department: educationData.department
      });

      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/apis/user/updateAcademicInformation`,
        {
          collegeName: educationData.collegeName,
          graduationYear: parseInt(educationData.graduationYear),
          degree: educationData.degree,
          department: educationData.department
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Response from server:", response.data);

      if (response.data && response.data.data) {
        // Update the state with the response data
        setEducationalData(response.data.data);
        toast.success(response.data.message || "Academic information saved successfully");
        setEducationModalOpen(false);
      } else {
        // If response doesn't have the expected structure, still close modal
        toast.success("Academic information saved successfully");
        setEducationModalOpen(false);
      }
    } catch (error) {
      console.error("Error updating academic information:", error);
      console.log("Error response:", error.response?.data);

      // Show specific error message if available
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to save academic information");
      }
    }
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5 }
    }
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.3 }
    },
    exit: {
      opacity: 0,
      scale: 0.8,
      transition: { duration: 0.2 }
    }
  };

  if (!profile) {
    return (
      <div className="w-full bg-gradient-to-br from-gray-50 via-white to-gray-50 rounded-2xl shadow-xl p-8 border border-gray-200">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600"></div>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="w-full bg-gradient-to-br from-gray-50 via-white to-gray-50 rounded-3xl shadow-xl p-6 md:p-8 border border-gray-200"
    >
      {/* Hidden file input for image upload */}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleImageSelect}
        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
        className="hidden"
      />

      {/* Profile Header */}
      <motion.div variants={itemVariants} className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-gray-200">
        <button
          onClick={handleEditClick}
          className="absolute top-4 right-4 p-3 bg-gray-100 hover:bg-gray-200 rounded-full transition shadow-md group"
          title="Edit Personal Information"
        >
          <HiOutlinePencil className="w-5 h-5 text-gray-600 group-hover:scale-110 transition" />
        </button>

        <div className="flex flex-col items-center">
          <div className="relative group mb-4">
            {/* Profile Image with Upload Overlay */}
            <div className="relative">
              <img
                src={imagePreview || profile?.image || "/assets/DefaultImage.jpg"}
                alt="Profile"
                className="w-28 h-28 rounded-full object-cover ring-4 ring-gray-200 shadow-xl group-hover:ring-gray-300 transition"
              />
              
              {/* Upload Overlay */}
              <div 
                onClick={handleCameraClick}
                className="absolute inset-0 bg-black/50 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
              >
                {uploadingImage ? (
                  <HiOutlineRefresh className="w-8 h-8 text-white animate-spin" />
                ) : (
                  <HiOutlineCamera className="w-8 h-8 text-white" />
                )}
              </div>

              {/* Upload Status Badge */}
              {uploadingImage && (
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs px-2 py-1 rounded-full whitespace-nowrap">
                  Uploading...
                </div>
              )}
            </div>

            {/* Success Check Icon (only show when image exists) */}
            {profile?.image && !uploadingImage && (
              <div className="absolute bottom-0 right-0 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-full p-2 shadow-lg border-2 border-white">
                <HiOutlineCheck className="w-4 h-4" />
              </div>
            )}
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold text-gray-700">
            {profile?.fullName || "Not Available"}
          </h2>
          <p className="text-gray-500 text-sm mt-2 flex items-center">
            <HiOutlineLocationMarker className="w-4 h-4 mr-1 text-gray-400" />
            {profile?.address || "Location not set"}
          </p>

          {/* Image Upload Hint */}
          <p className="text-xs text-gray-400 mt-2 flex items-center">
            <HiOutlinePhotograph className="w-3 h-3 mr-1" />
            Click on your profile picture to change it
          </p>
        </div>
      </motion.div>

      {/* Personal Info */}
      <motion.div variants={itemVariants} className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-gray-200">
        <h3 className="text-xl font-bold text-gray-700 mb-6 flex items-center">
          <HiOutlineUser className="w-5 h-5 mr-2 text-gray-500" />
          Personal Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-600 flex items-center">
              <HiOutlineMail className="w-4 h-4 mr-2 text-gray-500" />
              Email Address
            </label>
            <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
              {profile?.email || "Not Available"}
            </p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-semibold text-gray-600 flex items-center">
              <HiOutlinePhone className="w-4 h-4 mr-2 text-gray-500" />
              Phone Number
            </label>
            <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
              {profile?.phoneNumber || "Not Available"}
            </p>
          </div>

          <div className="space-y-2 md:col-span-2">
            <label className="text-sm font-semibold text-gray-600 flex items-center">
              <HiOutlineLocationMarker className="w-4 h-4 mr-2 text-gray-500" />
              Address
            </label>
            <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
              {profile?.address || "Not Available"}
            </p>
          </div>
        </div>
      </motion.div>

      {/* Education */}
      <motion.div variants={itemVariants} className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-200">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold text-gray-700 flex items-center">
            <HiOutlineAcademicCap className="w-5 h-5 mr-2 text-gray-500" />
            Education
          </h3>
          <button
            onClick={handleEducationEditClick}
            className="flex items-center space-x-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition group"
            title={educationalData ? "Edit Education" : "Add Education"}
          >
            {educationalData ? (
              <>
                <HiOutlinePencil className="w-4 h-4 text-gray-600 group-hover:scale-110 transition" />
                <span className="text-sm text-gray-700">Edit</span>
              </>
            ) : (
              <>
                <HiOutlinePlusCircle className="w-4 h-4 text-gray-600 group-hover:scale-110 transition" />
                <span className="text-sm text-gray-700">Add Education</span>
              </>
            )}
          </button>
        </div>

        {educationalData ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-600">College Name</label>
              <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
                {educationalData?.collegeName || "Not Available"}
              </p>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-600">Graduation Year</label>
              <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
                {educationalData?.graduationYear || "Not Available"}
              </p>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-600">Degree</label>
              <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
                {educationalData?.degree || "Not Available"}
              </p>
            </div>

            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-600">Department</label>
              <p className="text-gray-800 bg-gray-50 p-3 rounded-lg border border-gray-200">
                {educationalData?.department || "Not Available"}
              </p>
            </div>
          </div>
        ) : (
          <div className="text-center py-8 bg-gray-50 rounded-xl border border-gray-200">
            <HiOutlineAcademicCap className="w-12 h-12 text-gray-400 mx-auto mb-3" />
            <p className="text-gray-500">No education information added yet</p>
            <p className="text-sm text-gray-400 mt-1">Click the "Add Education" button to add your academic details</p>
          </div>
        )}
      </motion.div>

      {/* Edit Personal Info Modal (unchanged) */}
      <AnimatePresence>
        {editModalOpen && (
          <motion.div
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
            onClick={() => setEditModalOpen(false)}
          >
            <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 w-full max-w-md border border-gray-200" onClick={(e) => e.stopPropagation()}>
              <h2 className="text-2xl font-bold text-gray-700 mb-6">
                Edit Contact Info
              </h2>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
                  <input
                    type="email"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
                    value={editData.email}
                    onChange={(e) => setEditData({ ...editData, email: e.target.value })}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm mt-1 flex items-center">
                      <HiOutlineX className="w-4 h-4 mr-1" />
                      {errors.email}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Phone</label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
                    value={editData.phone}
                    onChange={(e) => setEditData({ ...editData, phone: e.target.value })}
                  />
                  {errors.phone && (
                    <p className="text-red-500 text-sm mt-1 flex items-center">
                      <HiOutlineX className="w-4 h-4 mr-1" />
                      {errors.phone}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Address</label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
                    value={editData.address}
                    onChange={(e) => setEditData({ ...editData, address: e.target.value })}
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-8">
                <button
                  className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
                  onClick={() => setEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-6 py-2.5 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition font-medium shadow-sm"
                  onClick={handleUpdate}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Edit Education Modal (unchanged) */}
      <AnimatePresence>
        {educationModalOpen && (
          <motion.div
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4 backdrop-blur-sm"
            onClick={() => setEducationModalOpen(false)}
          >
            <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 w-full max-w-md border border-gray-200 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
              <h2 className="text-2xl font-bold text-gray-700 mb-6 flex items-center">
                <HiOutlineAcademicCap className="w-6 h-6 mr-2 text-gray-500" />
                {educationalData ? "Edit Education" : "Add Education"}
              </h2>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">College Name</label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
                    placeholder="e.g., Stanford University"
                    value={educationData.collegeName}
                    onChange={(e) => setEducationData({ ...educationData, collegeName: e.target.value })}
                  />
                  {educationErrors.collegeName && (
                    <p className="text-red-500 text-sm mt-1 flex items-center">
                      <HiOutlineX className="w-4 h-4 mr-1" />
                      {educationErrors.collegeName}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Graduation Year</label>
                  <input
                    type="number"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
                    placeholder="e.g., 2024"
                    value={educationData.graduationYear}
                    onChange={(e) => setEducationData({ ...educationData, graduationYear: e.target.value })}
                  />
                  {educationErrors.graduationYear && (
                    <p className="text-red-500 text-sm mt-1 flex items-center">
                      <HiOutlineX className="w-4 h-4 mr-1" />
                      {educationErrors.graduationYear}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Degree</label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
                    placeholder="e.g., Bachelor of Science"
                    value={educationData.degree}
                    onChange={(e) => setEducationData({ ...educationData, degree: e.target.value })}
                  />
                  {educationErrors.degree && (
                    <p className="text-red-500 text-sm mt-1 flex items-center">
                      <HiOutlineX className="w-4 h-4 mr-1" />
                      {educationErrors.degree}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Department</label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 text-gray-700"
                    placeholder="e.g., Computer Science"
                    value={educationData.department}
                    onChange={(e) => setEducationData({ ...educationData, department: e.target.value })}
                  />
                  {educationErrors.department && (
                    <p className="text-red-500 text-sm mt-1 flex items-center">
                      <HiOutlineX className="w-4 h-4 mr-1" />
                      {educationErrors.department}
                    </p>
                  )}
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-8">
                <button
                  className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
                  onClick={() => setEducationModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-6 py-2.5 bg-gray-700 text-white rounded-lg hover:bg-gray-800 transition font-medium shadow-sm"
                  onClick={handleEducationUpdate}
                >
                  {educationalData ? "Update" : "Save"} Education
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default UserProfile;